import { STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_BEGIN } from "../constants"

export function dispatchAction({ id, actionCode, fields }){
    return (dispatch) =>{
        dispatch({
            type: STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_BEGIN,
            data: { id, actionCode, fields }
        })
    }
}
